import { render, staticRenderFns } from "./homeDashboardLeadStatistics.vue?vue&type=template&id=08a99a9c&scoped=true"
import script from "./homeDashboardLeadStatistics.vue?vue&type=script&lang=js"
export * from "./homeDashboardLeadStatistics.vue?vue&type=script&lang=js"
import style0 from "./homeDashboardLeadStatistics.vue?vue&type=style&index=0&id=08a99a9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a99a9c",
  null
  
)

export default component.exports